
import { Component, Vue } from "vue-property-decorator";

@Component
export default class TrendingIcon extends Vue {}
